import { computed, ref } from "vue";
import store from "../../store";
import { empty } from "../../../helpers";
import { i18n } from "../../../i18n";
import useProduct from "./useProduct";

export default function useCustom() {
  const { t } = i18n.global;
  const secondaryTextLimit = 150;
  const defaultPrimaryText = t("Primary text");
  const secondaryTextPlaceholder = t("Add secondary text max", {
    limit: secondaryTextLimit,
  });
  const { updateProductAttributeValue } = useProduct();

  // computed
  const primaryText = computed(() => getPrimaryText());

  function getPrimaryText() {
    const name = store.getters["product/getProduct"].attributes.primaryText;

    return empty(name) ? defaultPrimaryText : name;
  }

  function toggleSecondaryText(event) {
    const product = store.getters["product/getProduct"];
    const { checked } = event.target;

    store.commit("product/SET_SECONDARY_TEXT", checked);

    if (!checked) {
      delete product.attributes.secondaryText;
    }
  }

  function updatedFontType(index) {
    const product = store.getters["product/getProduct"];
    const type =
      store.getters["product/getAttributes"].fontType.attribute_values[index];

    updateProductAttributeValue("fontType", type);

    type.index = index;
    product.attribute_values.fontType = type;

    store.commit("product/SET_PRODUCT", product);
  }

  return {
    primaryText,
    defaultPrimaryText,
    secondaryTextPlaceholder,
    toggleSecondaryText,
    updatedFontType,
  };
}
